import type { components } from "@/services/policy-schema";

export const policies: components["schemas"]["Policy"][] = [
  {
    id: "1",
    name: "Withdrawal Policy",
    createdAt: "2023-01-15T10:30:00Z",
    updatedAt: "2023-01-15T10:30:00Z",
    settings: [
      {
        id: "2",
        type: "EXTERNAL_ADDRESS_ADDED",
        totalApprovers: 10,
        requiredApprovers: 5,
      },
    ],
  },
];

export const policiesResponse: components["schemas"]["Policies"] = {
  policies,
  pagination: {
    limit: 10,
    hasMore: true,
    total: 100,
    prevCursor: "abc123",
    nextCursor: "def456",
  },
};

export const policyResponse: components["schemas"]["Policy"] = policies[0];
